import { Box } from '@mui/material'
import { TabPill } from '../TabPill'

/**
 * [すべて | 遠隔 (新着 N)]。どこかの店の依頼先になっている店だけ描く。
 *
 * 新着の数は「遠隔」がアクティブでなくても出す — `list-and-status.md`「件数は chip がアクティブな
 * ときだけ」の例外(見落とすと頼んだ店が待つ)。04-apps/mamoru.md に登録する。
 * 新着 = まだ受領していない依頼。0 なら数字を出さない。
 */
export const RemoteFilterTabs = ({
  showsRemoteOnly,
  newCount,
  onChange,
}: {
  showsRemoteOnly: boolean
  newCount: number
  onChange: (showsRemoteOnly: boolean) => void
}) => (
  <Box role="tablist" sx={{ display: 'flex', gap: 0.5, px: 1, pb: 0.5 }}>
    <TabPill selected={!showsRemoteOnly} onClick={() => onChange(false)}>
      すべて
    </TabPill>
    <TabPill selected={showsRemoteOnly} onClick={() => onChange(true)}>
      {newCount > 0 ? `遠隔 (新着 ${newCount})` : '遠隔'}
    </TabPill>
  </Box>
)
